import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import LeagueToolbar from './LeagueToolbar';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Avatar from '@material-ui/core/Avatar';
import _ from 'lodash';
import ConfirmDialog from '../../components/ConfirmDialog';
import { removeLeagueMutation } from './mutations/removeLeagueMutation';
import { graphql, compose } from 'react-apollo';
import { isoCountries, getGameType, displayEnumType } from '../../utils';
import LocationOn from '@material-ui/icons/LocationOn';
import { getLeaguesQuery } from './queries/getLeaguesQuery';

const styles = theme => ({
	container: {
		position: 'relative',
		overflow: 'auto'
	},
	card: {
		// padding: 10,
		// margin: 24,
		// border: '1px solid rgba(0,0,0,0)',
		borderRadius: 8,
		border: '1px solid #EAEDF3',
		boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.04)',
		// boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
		// boxShadow: '#bfccdf 0px 1px 6px, #bfccdf 0px 1px 4px',
		transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
	},
	cell: {
		padding: '4px 30px 4px 20px',
		fontSize: 13
		// fontSize: 14
	},
	avatar: {
		width: 32,
		height: 32,
		backgroundColor: '#44475b',
		color: '#fff'
	}
});
class LeaguesList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dialogOpen: false,
			selectedLeague: null,
			order: 'asc',
			orderBy: 'name',
			selected: [],
			page: 0,
			rowsPerPage: 10,
			limit: this.props.limit || 10,
			offset: this.props.offset || 0
		};
		this.handleCloseDialog = this.handleCloseDialog.bind(this);
		this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.offset !== this.props.offset || nextProps.limit !== this.props.limit) {
			this.setState({
				offset: nextProps.offset,
				limit: nextProps.limit
			});
		}
	}

	handleRequestSort = (event, property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}

		this.setState({ order, orderBy });
	};

	handleChangePage = (event, page) => {
		this.setState({ page });
		this.props.onLoadMore();
	};

	handleChangeRowsPerPage = event => {
		this.setState({ rowsPerPage: event.target.value });
		this.props.onLoadMore();
	};

	handleCloseDialog() {
		this.setState({
			dialogOpen: false,
			selectedLeague: null
		});
	}

	handleConfirmDialog(league) {
		this.setState({
			selectedLeague: league,
			dialogOpen: true
		});
	}

	handleChangePage(event, page) {
		// this.setState({ page });
	}

	handleChangeRowsPerPage(event) {
		// this.setState({ rowsPerPage: event.target.value });
	}

	render() {
		const {
			classes,
			match,
			history,
			data,
			loading,
			error,
			subscribeToMore,
			count,
			onLoadMore,
			offset,
			limit
		} = this.props;

		const { order, orderBy, selected, rowsPerPage, page } = this.state;
		let emptyRows;

		if (!loading && data.divisions) {
			emptyRows = rowsPerPage - Math.min(rowsPerPage, data.leagues.length - page * rowsPerPage);
		}

		return (
			<React.Fragment>
				<Paper elevation={0} className={classes.card}>
					<div className={classes.container}>
						{loading && (
							<div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 15, paddingBottom: 15 }}>
								Loading...
							</div>
						)}
						{error && <div style={styles.container}>Error: {error.message}</div>}

						{!loading &&
							data.leagues && (
								<React.Fragment>
									{/*<DivisionToolbar data={data} />*/}
									<Table className={classes.table}>
										<TableHead>
											<TableRow>
												{/*<TableCell className={classes.cell}>#</TableCell>*/}
												<TableCell className={classes.cell}>Name</TableCell>
												<TableCell className={classes.cell}>Type</TableCell>
												{/*<TableCell className={classes.cell}>Season</TableCell>
    <TableCell className={classes.cell}>Week</TableCell>*/}
												<TableCell className={classes.cell}>Location(s)</TableCell>
												<TableCell className={classes.cell}>Operator</TableCell>
												<TableCell className={classes.cell}>Actions</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{data.leagues &&
												data.leagues.map((league, index) => {
													return (
														<TableRow
															key={league.id}
															hover
															onClick={() => history.push(`/leagues/${league.slug}`)}
															style={{ cursor: 'pointer' }}
														>
															{/*<TableCell className={classes.cell}>{index + 1}</TableCell>*/}
															<TableCell className={classes.cell}>
																<div style={{ display: 'flex', alignItems: 'center' }}>
																	<Avatar
																		size="small"
																		className={classes.avatar}
																		style={{ marginRight: 15 }}
																	>
																		{league.name.slice(0, 1)}
																	</Avatar>
																	<span style={{ whiteSpace: 'nowrap' }}>
																		{league.name}
																	</span>
																</div>
															</TableCell>
															<TableCell className={classes.cell}>
																{league.type}
															</TableCell>

															{/*<TableCell className={classes.cell}>{division.season}</TableCell>
                <TableCell className={classes.cell}>{division.week}</TableCell>*/}
															<TableCell className={classes.cell}>
																<div style={{ display: 'flex', alignItems: 'center' }}>
																	<LocationOn style={{ height: 18, marginRight: 10 }} />{' '}
																	{(league.locations &&
																		league.locations.map(location => {
																			return location.name;
																		})) ||
																		'N/A'}
																</div>
															</TableCell>
															<TableCell className={classes.cell}>
																{(league.operator && league.operator.name) || 'N/A'}
															</TableCell>
															<TableCell className={classes.cell}>
																<div style={{ display: 'flex', alignItems: 'center' }}>
																	<Button
																		color="primary"
																		size="small"
																		onClick={e => {
																			e.preventDefault();
																			e.stopPropagation();
																			history.push(
																				`/leagues/${league.slug}/edit`
																			);
																		}}
																	>
																		Edit
																	</Button>
																	<Button
																		color="primary"
																		size="small"
																		onClick={e => {
																			e.preventDefault();
																			e.stopPropagation();
																			this.handleConfirmDialog(league);
																		}}
																		style={{ color: 'rgb(225, 0, 80)' }}
																	>
																		Remove
																	</Button>
																</div>
															</TableCell>
														</TableRow>
													);
												})}
										</TableBody>
									</Table>
									<TablePagination
										component="div"
										count={data.leagues.length}
										rowsPerPage={50}
										rowsPerPageOptions={[50, 100, 200]}
										page={0}
										backIconButtonProps={{
											'aria-label': 'Previous Page'
										}}
										nextIconButtonProps={{
											'aria-label': 'Next Page'
										}}
										onChangePage={this.handleChangePage}
										onChangeRowsPerPage={this.handleChangeRowsPerPage}
									/>
									{this.state.dialogOpen === true && (
										<ConfirmDialog
											title="Confirm League Removal"
											open={this.state.dialogOpen}
											onClose={this.handleCloseDialog}
											onConfirm={() => {
												this.props
													.removeLeague({
														mutation: removeLeagueMutation,
														variables: { id: this.state.selectedLeague.id },
														// refetchQueries: ['GetLeagues'],
														refetchQueries: [
															{
																query: getLeaguesQuery
															}
														]
														// awaitRefetchQueries: true
													})
													.then(() => {
														this.setState({ dialogOpen: false });
													})
													.catch(error => {
														console.log(error);
														this.setState({ dialogOpen: false });
													});
											}}
										>
											⚠️ Are you sure you want to delete <b>{this.state.selectedLeague.name}</b>?
										</ConfirmDialog>
									)}
								</React.Fragment>
							)}
					</div>
				</Paper>
			</React.Fragment>
		);
	}
}

LeaguesList.contextTypes = {
	authUser: PropTypes.object,
	getUserProfile: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	changeLoginState: PropTypes.func,
	signIn: PropTypes.func,
	signOut: PropTypes.func
};

LeaguesList.propTypes = {
	classes: PropTypes.object.isRequired
};

const WithGraphQL = graphql(removeLeagueMutation, {
	options: ({ id }) => ({ variables: { id } }),
	name: 'removeLeague'
})(LeaguesList);

export default withStyles(styles)(WithGraphQL);
